// AUTO-GENERATED (gen_feed_i18n.py). Chicken feed calculator, 22 languages.
export const FEED_GEN = {
 "fr": {
  "slug": "calculateur-aliment-poules",
  "title": "Calculateur d'aliment pour poules | Ma Petite Ferme",
  "metaDescription": "Calculez gratuitement la quantité d'aliment pour vos poules et son coût par mois et par an, selon le nombre de poules et la consommation quotidienne.",
  "h1": "Calculateur d'aliment pour poules",
  "intro": "Estimez la quantité d'aliment nécessaire pour votre cheptel et son coût. Ajustez le nombre de poules, la consommation quotidienne et le prix de l'aliment.",
  "hens": "Nombre de poules",
  "feedPerHen": "Consommation par poule (g/jour)",
  "feedPrice": "Prix de l'aliment (€/kg)",
  "resultTitle": "Besoins estimés",
  "perDay": "Par jour",
  "perMonth": "Par mois",
  "perYear": "Par an",
  "costMonth": "Coût mensuel",
  "costYear": "Coût annuel",
  "kgUnit": "kg",
  "disclaimer": "Estimation indicative. La consommation réelle varie selon la race, l'âge, la saison et l'accès au parcours.",
  "ctaTitle": "Gérez vos stocks d'aliment avec Ma Petite Ferme",
  "ctaText": "Suivez vos achats d'aliment, vos coûts et votre cheptel au quotidien, en toute simplicité.",
  "ctaBtn": "Créer ma ferme gratuitement"
 },
 "es": {
  "slug": "calculadora-alimento-gallinas",
  "title": "Calculadora de alimento para gallinas | Ma Petite Ferme",
  "metaDescription": "Calcula gratis la cantidad de alimento para tus gallinas y su coste mensual y anual, según el número de gallinas y el consumo diario.",
  "h1": "Calculadora de alimento para gallinas",
  "intro": "Estima la cantidad de alimento necesaria para tu gallinero y su coste. Ajusta el número de gallinas, el consumo diario y el precio del alimento.",
  "hens": "Número de gallinas",
  "feedPerHen": "Consumo por gallina (g/día)",
  "feedPrice": "Precio del alimento (€/kg)",
  "resultTitle": "Necesidades estimadas",
  "perDay": "Por día",
  "perMonth": "Por mes",
  "perYear": "Por año",
  "costMonth": "Coste mensual",
  "costYear": "Coste anual",
  "kgUnit": "kg",
  "disclaimer": "Estimación orientativa. El consumo real varía según la raza, la edad, la temporada y el acceso al patio o parcela.",
  "ctaTitle": "Gestiona tu stock de alimento con Ma Petite Ferme",
  "ctaText": "Lleva el seguimiento de tus compras de alimento, tus costes y tu gallinero día a día, de forma sencilla.",
  "ctaBtn": "Crear mi granja gratis"
 },
 "en": {
  "slug": "chicken-feed-calculator",
  "title": "Chicken Feed Calculator | Ma Petite Ferme",
  "metaDescription": "Free chicken feed calculator: estimate daily, monthly and yearly feed quantity and cost based on flock size and daily consumption.",
  "h1": "Chicken Feed Calculator",
  "intro": "Estimate how much feed your flock needs and what it will cost. Adjust the number of hens, daily intake per bird, and feed price to get your figures.",
  "hens": "Number of hens",
  "feedPerHen": "Feed per hen (g/day)",
  "feedPrice": "Feed price ($/kg)",
  "resultTitle": "Estimated needs",
  "perDay": "Per day",
  "perMonth": "Per month",
  "perYear": "Per year",
  "costMonth": "Monthly cost",
  "costYear": "Yearly cost",
  "kgUnit": "kg",
  "disclaimer": "Indicative estimate only. Actual consumption varies depending on breed, age, season and access to free range.",
  "ctaTitle": "Manage your feed stock with Ma Petite Ferme",
  "ctaText": "Track your feed purchases, costs and flock day by day, simply and effortlessly.",
  "ctaBtn": "Create my farm for free"
 },
 "it": {
  "slug": "calcolatore-mangime-galline",
  "title": "Calcolatore mangime per galline | Ma Petite Ferme",
  "metaDescription": "Calcola gratis la quantità di mangime per le tue galline e il costo mensile e annuale, in base al numero di galline e al consumo giornaliero.",
  "h1": "Calcolatore di mangime per galline",
  "intro": "Stima la quantità di mangime necessaria per il tuo pollame e il relativo costo. Regola il numero di galline, il consumo giornaliero e il prezzo del mangime.",
  "hens": "Numero di galline",
  "feedPerHen": "Consumo per gallina (g/giorno)",
  "feedPrice": "Prezzo del mangime (€/kg)",
  "resultTitle": "Fabbisogno stimato",
  "perDay": "Al giorno",
  "perMonth": "Al mese",
  "perYear": "All'anno",
  "costMonth": "Costo mensile",
  "costYear": "Costo annuale",
  "kgUnit": "kg",
  "disclaimer": "Stima indicativa. Il consumo reale varia in base alla razza, all'età, alla stagione e all'accesso al pascolo.",
  "ctaTitle": "Gestisci le scorte di mangime con Ma Petite Ferme",
  "ctaText": "Tieni traccia degli acquisti di mangime, dei costi e del tuo pollame ogni giorno, in modo semplice e intuitivo.",
  "ctaBtn": "Crea la mia fattoria gratuitamente"
 },
 "sv": {
  "slug": "kalkylator-honsmat",
  "title": "Kalkylator för hönsmat | Ma Petite Ferme",
  "metaDescription": "Beräkna gratis mängden hönsmat och kostnaden per månad och år, baserat på antal höns och daglig förbrukning per höna.",
  "h1": "Kalkylator för hönsmat",
  "intro": "Uppskatta hur mycket mat dina höns behöver och vad det kostar. Justera antal höns, daglig förbrukning och matpris.",
  "hens": "Antal höns",
  "feedPerHen": "Förbrukning per höna (g/dag)",
  "feedPrice": "Matpris (kr/kg)",
  "resultTitle": "Uppskattade behov",
  "perDay": "Per dag",
  "perMonth": "Per månad",
  "perYear": "Per år",
  "costMonth": "Månadskostnad",
  "costYear": "Årskostnad",
  "kgUnit": "kg",
  "disclaimer": "Indikativ uppskattning. Den faktiska förbrukningen varierar beroende på ras, ålder, årstid och tillgång till utevistelse.",
  "ctaTitle": "Håll koll på ditt foder med Ma Petite Ferme",
  "ctaText": "Följ dina matinköp, kostnader och din flock i vardagen, enkelt och smidigt.",
  "ctaBtn": "Skapa min gård gratis"
 },
 "nl": {
  "slug": "voerberekening-kippen",
  "title": "Voerberekening voor kippen | Ma Petite Ferme",
  "metaDescription": "Bereken gratis hoeveel voer uw kippen nodig hebben en wat dit kost per maand en per jaar, op basis van uw koppelgrootte en dagelijkse consumptie.",
  "h1": "Voerberekening voor kippen",
  "intro": "Schat de hoeveelheid voer die uw koppel nodig heeft en de bijbehorende kosten. Pas het aantal kippen, de dagelijkse consumptie en de voerprijs aan.",
  "hens": "Aantal kippen",
  "feedPerHen": "Verbruik per kip (g/dag)",
  "feedPrice": "Prijs van het voer (€/kg)",
  "resultTitle": "Geschatte behoeften",
  "perDay": "Per dag",
  "perMonth": "Per maand",
  "perYear": "Per jaar",
  "costMonth": "Maandelijkse kosten",
  "costYear": "Jaarlijkse kosten",
  "kgUnit": "kg",
  "disclaimer": "Indicatieve schatting. Het werkelijke verbruik varieert naargelang het ras, de leeftijd, het seizoen en de toegang tot een uitloop.",
  "ctaTitle": "Beheer uw voervoorraden met Ma Petite Ferme",
  "ctaText": "Volg uw voerankopen, uw kosten en uw koppel dag na dag, eenvoudig en overzichtelijk.",
  "ctaBtn": "Maak mijn boerderij gratis aan"
 },
 "de": {
  "slug": "huehnerfutter-rechner",
  "title": "Hühnerfutter-Rechner | Ma Petite Ferme",
  "metaDescription": "Berechnen Sie kostenlos die Futtermenge für Ihre Hühner sowie die monatlichen und jährlichen Kosten – nach Herdengröße und Tagesverbrauch.",
  "h1": "Hühnerfutter-Rechner",
  "intro": "Schätzen Sie den Futterbedarf Ihrer Herde und die anfallenden Kosten. Passen Sie die Anzahl der Hühner, den täglichen Verbrauch und den Futterpreis an.",
  "hens": "Anzahl der Hühner",
  "feedPerHen": "Verbrauch pro Huhn (g/Tag)",
  "feedPrice": "Futterpreis (€/kg)",
  "resultTitle": "Geschätzter Bedarf",
  "perDay": "Pro Tag",
  "perMonth": "Pro Monat",
  "perYear": "Pro Jahr",
  "costMonth": "Monatliche Kosten",
  "costYear": "Jährliche Kosten",
  "kgUnit": "kg",
  "disclaimer": "Richtwert. Der tatsächliche Verbrauch variiert je nach Rasse, Alter, Jahreszeit und Zugang zum Freigelände.",
  "ctaTitle": "Verwalten Sie Ihre Futtervorräte mit Ma Petite Ferme",
  "ctaText": "Behalten Sie Ihre Futtereinkäufe, Kosten und Ihre Herde ganz einfach im Überblick – jeden Tag.",
  "ctaBtn": "Meine Hühnerfarm kostenlos anlegen"
 },
 "da": {
  "slug": "beregner-honsefoder",
  "title": "Beregner til hønsefoder | Ma Petite Ferme",
  "metaDescription": "Beregn gratis mængden af foder til dine høns og de månedlige og årlige omkostninger – tilpas antal høns og dagligt forbrug.",
  "h1": "Beregner til hønsefoder",
  "intro": "Estimer den nødvendige fodermængde til din flok og hvad det koster. Juster antal høns, dagligt forbrug og prisen på foderet.",
  "hens": "Antal høns",
  "feedPerHen": "Forbrug pr. høne (g/dag)",
  "feedPrice": "Pris på foder (kr./kg)",
  "resultTitle": "Estimeret behov",
  "perDay": "Pr. dag",
  "perMonth": "Pr. måned",
  "perYear": "Pr. år",
  "costMonth": "Månedlige omkostninger",
  "costYear": "Årlige omkostninger",
  "kgUnit": "kg",
  "disclaimer": "Vejledende estimat. Det faktiske forbrug varierer afhængigt af race, alder, årstid og adgang til udearealer.",
  "ctaTitle": "Styr dit hønsefoder med Ma Petite Ferme",
  "ctaText": "Følg dine foderudgifter, omkostninger og din flok i hverdagen – nemt og overskueligt.",
  "ctaBtn": "Opret min gård gratis"
 },
 "bg": {
  "slug": "kalkulator-hrana-za-kokoshki",
  "title": "Калкулатор за храна на кокошки | Ma Petite Ferme",
  "metaDescription": "Изчислете безплатно количеството храна за вашите кокошки и разходите на месец и година според броя птици и дневната консумация.",
  "h1": "Калкулатор за храна на кокошки",
  "intro": "Изчислете необходимото количество храна за вашето стадо и разходите за нея. Задайте броя кокошки, дневната консумация и цената на фуража.",
  "hens": "Брой кокошки",
  "feedPerHen": "Консумация на кокошка (г/ден)",
  "feedPrice": "Цена на фуража (лв/кг)",
  "resultTitle": "Приблизителни нужди",
  "perDay": "На ден",
  "perMonth": "На месец",
  "perYear": "На година",
  "costMonth": "Месечен разход",
  "costYear": "Годишен разход",
  "kgUnit": "кг",
  "disclaimer": "Приблизителна оценка. Реалната консумация варира според породата, възрастта, сезона и достъпа до пасище.",
  "ctaTitle": "Управлявайте запасите си с Ma Petite Ferme",
  "ctaText": "Следете покупките на фураж, разходите и вашето стадо всеки ден — лесно и удобно.",
  "ctaBtn": "Създай моята ферма безплатно"
 },
 "hr": {
  "slug": "kalkulator-hrane-za-kokosi",
  "title": "Kalkulator hrane za kokoši | Ma Petite Ferme",
  "metaDescription": "Besplatno izračunajte količinu hrane za vaše kokoši i troškove po mjesecu i godini, prema broju kokoši i dnevnoj potrošnji.",
  "h1": "Kalkulator hrane za kokoši",
  "intro": "Procijenite količinu hrane potrebnu za vaše jato i njezin trošak. Prilagodite broj kokoši, dnevnu potrošnju i cijenu hrane.",
  "hens": "Broj kokoši",
  "feedPerHen": "Potrošnja po kokoši (g/dan)",
  "feedPrice": "Cijena hrane (€/kg)",
  "resultTitle": "Procijenjene potrebe",
  "perDay": "Po danu",
  "perMonth": "Po mjesecu",
  "perYear": "Po godini",
  "costMonth": "Mjesečni trošak",
  "costYear": "Godišnji trošak",
  "kgUnit": "kg",
  "disclaimer": "Okvirna procjena. Stvarna potrošnja varira ovisno o pasmini, dobi, godišnjem dobu i pristupu ispustu.",
  "ctaTitle": "Upravljajte zalihama hrane uz Ma Petite Ferme",
  "ctaText": "Pratite kupovinu hrane, troškove i svoje jato svakodnevno, jednostavno i pregledno.",
  "ctaBtn": "Stvori svoju farmu besplatno"
 },
 "et": {
  "slug": "kanatoidu-koguse-kalkulaator",
  "title": "Kanatoidu kalkulaator | Ma Petite Ferme",
  "metaDescription": "Arvuta tasuta oma kanade toidukogus ja maksumus kuus ning aastas. Sisesta kanade arv, päevane tarbimine ja toidu hind.",
  "h1": "Kanatoidu koguse ja kulu kalkulaator",
  "intro": "Hinda oma karja jaoks vajalikku toidukogust ja selle maksumust. Muuda kanade arvu, päevast tarbimist ja toidu hinda.",
  "hens": "Kanade arv",
  "feedPerHen": "Tarbimine kana kohta (g/päev)",
  "feedPrice": "Toidu hind (€/kg)",
  "resultTitle": "Hinnanguline vajadus",
  "perDay": "Päevas",
  "perMonth": "Kuus",
  "perYear": "Aastas",
  "costMonth": "Kuu maksumus",
  "costYear": "Aasta maksumus",
  "kgUnit": "kg",
  "disclaimer": "Ligikaudne hinnang. Tegelik tarbimine sõltub tõust, vanusest, aastaajast ja väljapääsust karjamaale.",
  "ctaTitle": "Halda oma kanatoidu varusid Ma Petite Ferme abil",
  "ctaText": "Jälgi oma toidu oste, kulusid ja karja iga päev - lihtsalt ja mugavalt.",
  "ctaBtn": "Loo oma farm tasuta"
 },
 "el": {
  "slug": "ypologistis-trofis-kottes",
  "title": "Υπολογιστής τροφής για κότες | Ma Petite Ferme",
  "metaDescription": "Υπολογίστε δωρεάν την ποσότητα τροφής για τις κότες σας και το κόστος ανά μήνα και ανά έτος, ανάλογα με τον αριθμό κοτών και την ημερήσια κατανάλωση.",
  "h1": "Υπολογιστής τροφής για κότες",
  "intro": "Εκτιμήστε την ποσότητα τροφής που χρειάζεται το κοπάδι σας και το κόστος της. Ρυθμίστε τον αριθμό των κοτών, την ημερήσια κατανάλωση και την τιμή της τροφής.",
  "hens": "Αριθμός κοτών",
  "feedPerHen": "Κατανάλωση ανά κότα (g/ημέρα)",
  "feedPrice": "Τιμή τροφής (€/kg)",
  "resultTitle": "Εκτιμώμενες ανάγκες",
  "perDay": "Ανά ημέρα",
  "perMonth": "Ανά μήνα",
  "perYear": "Ανά έτος",
  "costMonth": "Μηνιαίο κόστος",
  "costYear": "Ετήσιο κόστος",
  "kgUnit": "kg",
  "disclaimer": "Ενδεικτική εκτίμηση. Η πραγματική κατανάλωση ποικίλλει ανάλογα με τη φυλή, την ηλικία, την εποχή και την πρόσβαση σε ελεύθερη βοσκή.",
  "ctaTitle": "Διαχειριστείτε τα αποθέματα τροφής σας με το Ma Petite Ferme",
  "ctaText": "Παρακολουθήστε τις αγορές τροφής, τα κόστη και το κοπάδι σας καθημερινά, με απόλυτη απλότητα.",
  "ctaBtn": "Δημιουργήστε τη φάρμα μου δωρεάν"
 },
 "fi": {
  "slug": "kanojen-rehumaaran-laskuri",
  "title": "Kanojen rehumäärälaskuri | Ma Petite Ferme",
  "metaDescription": "Laske ilmaiseksi kanojen rehuntarve sekä kuukausittaiset ja vuosittaiset rehukustannukset kanalukumäärän ja päiväkulutuksen mukaan.",
  "h1": "Kanojen rehumäärälaskuri",
  "intro": "Arvioi kanojesi päivittäinen rehuntarve ja sen kustannukset. Säädä kanojen lukumäärää, päiväkulutusta ja rehun hintaa.",
  "hens": "Kanojen lukumäärä",
  "feedPerHen": "Kulutus kanaa kohden (g/vrk)",
  "feedPrice": "Rehun hinta (€/kg)",
  "resultTitle": "Arvioitu rehuntarve",
  "perDay": "Päivässä",
  "perMonth": "Kuukaudessa",
  "perYear": "Vuodessa",
  "costMonth": "Kuukausikustannus",
  "costYear": "Vuosikustannus",
  "kgUnit": "kg",
  "disclaimer": "Arvio on suuntaa-antava. Todellinen kulutus vaihtelee rodun, iän, vuodenajan ja ulkotarhan käytön mukaan.",
  "ctaTitle": "Hallitse rehuvarastosi Ma Petite Ferme -sovelluksella",
  "ctaText": "Seuraa rehuostoksiasi, kustannuksiasi ja kanalukumäärääsi helposti päivittäin.",
  "ctaBtn": "Luo tilani ilmaiseksi"
 },
 "hu": {
  "slug": "tyuk-takarmany-kalkulator",
  "title": "Tyúk takarmánykalkulátor | Ma Petite Ferme",
  "metaDescription": "Számítsd ki ingyenesen tyúkjaid takarmányszükségletét és havi, éves költségét a csapat mérete és a napi fogyasztás alapján.",
  "h1": "Tyúk takarmánykalkulátor",
  "intro": "Becsüld meg az állományod takarmányszükségletét és annak költségét. Állítsd be a tyúkok számát, a napi fogyasztást és a takarmány árát.",
  "hens": "Tyúkok száma",
  "feedPerHen": "Fogyasztás tyúkonként (g/nap)",
  "feedPrice": "Takarmány ára (Ft/kg)",
  "resultTitle": "Becsült szükséglet",
  "perDay": "Naponta",
  "perMonth": "Havonta",
  "perYear": "Évente",
  "costMonth": "Havi költség",
  "costYear": "Éves költség",
  "kgUnit": "kg",
  "disclaimer": "Tájékoztató jellegű becslés. A tényleges fogyasztás a fajtától, kortól, évszaktól és a kifutó méretétől függően változhat.",
  "ctaTitle": "Kezelje takarmánykészleteit a Ma Petite Ferme segítségével",
  "ctaText": "Kövesse nyomon takarmánybeszerzéseit, költségeit és állományát nap mint nap, egyszerűen és átláthatóan.",
  "ctaBtn": "Hozza létre farmját ingyenesen"
 },
 "pt": {
  "slug": "calculadora-alimento-galinhas",
  "title": "Calculadora de alimento para galinhas | Ma Petite Ferme",
  "metaDescription": "Calcule gratuitamente a quantidade de alimento para as suas galinhas e o custo mensal e anual, conforme o numero de aves e o consumo diario.",
  "h1": "Calculadora de alimento para galinhas",
  "intro": "Estime a quantidade de alimento necessaria para o seu bando e o respetivo custo. Ajuste o numero de galinhas, o consumo diario e o preco do alimento.",
  "hens": "Numero de galinhas",
  "feedPerHen": "Consumo por galinha (g/dia)",
  "feedPrice": "Preco do alimento (€/kg)",
  "resultTitle": "Necessidades estimadas",
  "perDay": "Por dia",
  "perMonth": "Por mes",
  "perYear": "Por ano",
  "costMonth": "Custo mensal",
  "costYear": "Custo anual",
  "kgUnit": "kg",
  "disclaimer": "Estimativa indicativa. O consumo real varia conforme a raca, a idade, a estacao do ano e o acesso ao espaco exterior.",
  "ctaTitle": "Gira os seus stocks de alimento com a Ma Petite Ferme",
  "ctaText": "Acompanhe as suas compras de alimento, os seus custos e o seu bando no dia a dia, de forma simples e pratica.",
  "ctaBtn": "Criar a minha quinta gratuitamente"
 },
 "lv": {
  "slug": "vistas-bariba-kalkulators",
  "title": "Vistu barības kalkulators | Ma Petite Ferme",
  "metaDescription": "Aprēķiniet bez maksas barības daudzumu savām vistām un izmaksas mēnesī un gadā pēc vistu skaita un ikdienas patēriņa.",
  "h1": "Vistu barības kalkulators",
  "intro": "Novērtējiet nepieciešamo barības daudzumu jūsu ganāmpulkam un tā izmaksas. Pielāgojiet vistu skaitu, ikdienas patēriņu un barības cenu.",
  "hens": "Vistu skaits",
  "feedPerHen": "Patēriņš uz vistu (g/dienā)",
  "feedPrice": "Barības cena (€/kg)",
  "resultTitle": "Aprēķinātās vajadzības",
  "perDay": "Dienā",
  "perMonth": "Mēnesī",
  "perYear": "Gadā",
  "costMonth": "Mēneša izmaksas",
  "costYear": "Gada izmaksas",
  "kgUnit": "kg",
  "disclaimer": "Indikatīvs aprēķins. Faktiskais patēriņš var atšķirties atkarībā no šķirnes, vecuma, sezonas un piekļuves ganībām.",
  "ctaTitle": "Pārvaldiet barības krājumus ar Ma Petite Ferme",
  "ctaText": "Sekojiet līdzi barības iegādei, izmaksām un savam ganāmpulkam katru dienu — vienkārši un ērti.",
  "ctaBtn": "Izveidot savu fermu bez maksas"
 },
 "pl": {
  "slug": "kalkulator-paszy-dla-kur",
  "title": "Kalkulator paszy dla kur | Ma Petite Ferme",
  "metaDescription": "Oblicz bezpłatnie ilość paszy dla swoich kur i jej koszt miesięczny oraz roczny, zależnie od liczby kur i dziennego spożycia.",
  "h1": "Kalkulator paszy dla kur",
  "intro": "Oszacuj ilość paszy potrzebnej dla swojego stada oraz jej koszt. Dostosuj liczbę kur, dzienne spożycie i cenę paszy.",
  "hens": "Liczba kur",
  "feedPerHen": "Spożycie na kurę (g/dzień)",
  "feedPrice": "Cena paszy (zł/kg)",
  "resultTitle": "Szacowane zapotrzebowanie",
  "perDay": "Dziennie",
  "perMonth": "Miesięcznie",
  "perYear": "Rocznie",
  "costMonth": "Koszt miesięczny",
  "costYear": "Koszt roczny",
  "kgUnit": "kg",
  "disclaimer": "Szacunek orientacyjny. Rzeczywiste spożycie zależy od rasy, wieku, pory roku i dostępu do wybiegu.",
  "ctaTitle": "Zarządzaj zapasami paszy z Ma Petite Ferme",
  "ctaText": "Śledź zakupy paszy, koszty i swoje stado na co dzień, w prosty i wygodny sposób.",
  "ctaBtn": "Załóż swoją fermę za darmo"
 },
 "lt": {
  "slug": "vistienu-paaro-skaiciuokle",
  "title": "Vištienos pašaro skaičiuoklė | Ma Petite Ferme",
  "metaDescription": "Apskaičiuokite nemokamai pašaro kiekį savo vištoms ir jo kainą per mėnesį bei metus pagal vištų skaičių ir paros suvartojimą.",
  "h1": "Vištų pašaro skaičiuoklė",
  "intro": "Įvertinkite pašaro kiekį, reikalingą jūsų bandai, ir jo kainą. Sureguliuokite vištų skaičių, paros suvartojimą ir pašaro kainą.",
  "hens": "Vištų skaičius",
  "feedPerHen": "Suvartojimas vienai vištai (g/dieną)",
  "feedPrice": "Pašaro kaina (€/kg)",
  "resultTitle": "Apytiksliai poreikiai",
  "perDay": "Per dieną",
  "perMonth": "Per mėnesį",
  "perYear": "Per metus",
  "costMonth": "Mėnesio kaina",
  "costYear": "Metinė kaina",
  "kgUnit": "kg",
  "disclaimer": "Apytiksliai skaičiavimai. Realus suvartojimas priklauso nuo veislės, amžiaus, sezono ir galimybės lakstyti lauke.",
  "ctaTitle": "Tvarkykite pašaro atsargas su Ma Petite Ferme",
  "ctaText": "Sekite pašaro pirkimus, išlaidas ir savo bandą kasdien – paprastai ir patogiai.",
  "ctaBtn": "Kurti savo ūkelį nemokamai"
 },
 "ro": {
  "slug": "calculator-hrana-gaini",
  "title": "Calculator hrana gaini | Ma Petite Ferme",
  "metaDescription": "Calculeaza gratuit cantitatea de hrana pentru gainile tale si costul pe luna si pe an, in functie de numarul de gaini si consumul zilnic.",
  "h1": "Calculator de hrana pentru gaini",
  "intro": "Estimeaza cantitatea de hrana necesara pentru efectivul tau si costul aferent. Ajusteaza numarul de gaini, consumul zilnic si pretul hranei.",
  "hens": "Numar de gaini",
  "feedPerHen": "Consum pe gaina (g/zi)",
  "feedPrice": "Pretul hranei (lei/kg)",
  "resultTitle": "Necesar estimat",
  "perDay": "Pe zi",
  "perMonth": "Pe luna",
  "perYear": "Pe an",
  "costMonth": "Cost lunar",
  "costYear": "Cost anual",
  "kgUnit": "kg",
  "disclaimer": "Estimare orientativa. Consumul real variaza in functie de rasa, varsta, anotimp si accesul la spatiul de miscare.",
  "ctaTitle": "Gestioneaza stocurile de hrana cu Ma Petite Ferme",
  "ctaText": "Urmareste achizitiile de hrana, costurile si efectivul tau zilnic, simplu si usor.",
  "ctaBtn": "Creeaza-mi ferma gratuit"
 },
 "cs": {
  "slug": "kalkulator-krmiva-pro-slepice",
  "title": "Kalkulátor krmiva pro slepice | Ma Petite Ferme",
  "metaDescription": "Zdarma vypočítejte množství krmiva pro vaše slepice a náklady za měsíc i rok podle počtu slepic a denní spotřeby krmiva.",
  "h1": "Kalkulátor krmiva pro slepice",
  "intro": "Odhadněte množství krmiva potřebného pro vaše hejno a jeho náklady. Upravte počet slepic, denní spotřebu a cenu krmiva.",
  "hens": "Počet slepic",
  "feedPerHen": "Spotřeba na slepici (g/den)",
  "feedPrice": "Cena krmiva (Kč/kg)",
  "resultTitle": "Odhadovaná spotřeba",
  "perDay": "Za den",
  "perMonth": "Za měsíc",
  "perYear": "Za rok",
  "costMonth": "Měsíční náklady",
  "costYear": "Roční náklady",
  "kgUnit": "kg",
  "disclaimer": "Orientační odhad. Skutečná spotřeba se liší podle plemene, věku, ročního období a přístupu na výběh.",
  "ctaTitle": "Spravujte zásoby krmiva s Ma Petite Ferme",
  "ctaText": "Sledujte nákupy krmiva, náklady a své hejno každý den jednoduše a přehledně.",
  "ctaBtn": "Vytvořit mou farmu zdarma"
 },
 "sk": {
  "slug": "kalkulacka-krmiva-pre-sliepky",
  "title": "Kalkulačka krmiva pre sliepky | Ma Petite Ferme",
  "metaDescription": "Vypočítajte si zadarmo množstvo krmiva pre vaše sliepky a jeho mesačné či ročné náklady podľa počtu sliepok a dennej spotreby.",
  "h1": "Kalkulačka krmiva pre sliepky",
  "intro": "Odhadnite množstvo krmiva potrebného pre váš chov a jeho náklady. Upravte počet sliepok, dennú spotrebu a cenu krmiva.",
  "hens": "Počet sliepok",
  "feedPerHen": "Spotreba na sliepku (g/deň)",
  "feedPrice": "Cena krmiva (€/kg)",
  "resultTitle": "Odhadovaná potreba",
  "perDay": "Za deň",
  "perMonth": "Za mesiac",
  "perYear": "Za rok",
  "costMonth": "Mesačné náklady",
  "costYear": "Ročné náklady",
  "kgUnit": "kg",
  "disclaimer": "Orientačný odhad. Skutočná spotreba sa líši podľa plemena, veku, ročného obdobia a prístupu na výbeh.",
  "ctaTitle": "Spravujte zásoby krmiva s Ma Petite Ferme",
  "ctaText": "Sledujte nákupy krmiva, náklady a váš chov každý deň, jednoducho a prehľadne.",
  "ctaBtn": "Vytvoriť moju farmu zadarmo"
 },
 "sl": {
  "slug": "kalkulator-krme-za-kokosi",
  "title": "Kalkulator krme za kokoši | Ma Petite Ferme",
  "metaDescription": "Brezplačno izračunajte količino krme za vaše kokoši in stroške na mesec ter leto glede na število kokoši in dnevno porabo.",
  "h1": "Kalkulator krme za kokoši",
  "intro": "Ocenite količino krme, ki jo potrebuje vaša jata, in njene stroške. Prilagodite število kokoši, dnevno porabo in ceno krme.",
  "hens": "Število kokoši",
  "feedPerHen": "Poraba na kokoš (g/dan)",
  "feedPrice": "Cena krme (€/kg)",
  "resultTitle": "Ocenjene potrebe",
  "perDay": "Na dan",
  "perMonth": "Na mesec",
  "perYear": "Na leto",
  "costMonth": "Mesečni strošek",
  "costYear": "Letni strošek",
  "kgUnit": "kg",
  "disclaimer": "Okvirna ocena. Dejanska poraba se razlikuje glede na pasmo, starost, letni čas in dostop do izpusta.",
  "ctaTitle": "Upravljajte zaloge krme z Ma Petite Ferme",
  "ctaText": "Enostavno spremljajte nakupe krme, stroške in svojo jato vsak dan.",
  "ctaBtn": "Ustvari svojo kmetijo brezplačno"
 }
};
